import styles from "./ArticleMeta.module.scss";
import cx from "classnames";

const ArticleMeta = ({
  isIdeasArticle,
  children,
}: {
  isIdeasArticle: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div className={cx(styles.root, isIdeasArticle && styles.ideasRoot)}>
      {children}
    </div>
  );
};

export default ArticleMeta;
